import { Button } from '@aqarmap/aqarmap-ui';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFullRoutes } from '~/hooks';
import { formatNumber } from '~/lib';
import ServicesList from '~/pages/Packages/ServicesList';
import { PackagesGridPlanType } from '~/pages/Packages/utils';

export default function AddonSection({
  addonsPlans,
}: {
  addonsPlans: PackagesGridPlanType[];
}) {
  const navigate = useNavigate();
  const { PACKAGES_URL, SUBSCRIPTION_URL } = useFullRoutes();
  const { t } = useTranslation('app');

  return (
    <div className="flex flex-col items-center gap-3x md:gap-4x ">
      <div className="flex flex-col gap-1.5x items-center">
        <p className="text-title-2 text-black">{t('addonsPackagesTitle')}</p>
        <p className="text-body-1 text-black  hidden md:block">
          {t('addonsPackageDescription')}
        </p>
      </div>
      <div className="flex w-full flex-wrap items-stretch justify-center gap-3x md:gap-5x">
        {addonsPlans.map((plan) => {
          return (
            <div key={plan.key} className="flex w-full md:max-w-[255.33px]">
              <div className="flex h-full flex-col w-full overflow-hidden rounded-t-[16px] rounded-b-[24px] bg-gray_light_1 ">
                <div className="flex w-full items-center justify-center py-x">
                  <p className="text-title-5 text-gray__dark_2 min-h-[24px]">
                    {plan.title}
                  </p>
                </div>
                <div className="flex h-full flex-col gap-2x rounded-t-[16px] rounded-b-[24px] border border-gray bg-white px-3x py-3x">
                  <ServicesList plan={plan} />

                  <div className="mt-auto flex flex-col gap-3x border-t border-gray_light_1 pt-2x">
                    <div className="flex items-center gap-x  ">
                      <p className="text-title-3 text-black">
                        {formatNumber(Number(plan.price))}
                      </p>
                      <p className="text-body-2 text-black">
                        {t('egpPerMonth')}
                      </p>
                    </div>

                    <Button
                      variant="primary"
                      size="medium"
                      onClick={() =>
                        navigate(
                          plan.type === 'subscription'
                            ? SUBSCRIPTION_URL.CHECKOUT(plan.checkoutId)
                            : PACKAGES_URL.CHECKOUT(plan.checkoutId),
                        )
                      }
                    >
                      {t('addToMyPackage')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
